<!--
create by melody on 2018/11/1
description:数据权限配置页面
-->
<template>
	<div>
		<page-header :title="title"></page-header>
		<div class="hdp-uf hdp-uf-dc search-container">
			<div class="hdp-uf hdp-uf-hsb">
				<el-row style="width:100%">
					<el-col style="width:35%">
						<div class="hdp-uf">
							<div class="hdp-uf hdp-uf-vc">{{$t('m.OAAccount')}}：</div>
							<el-select v-model="searchParam.account" filterable style="width:70%;" clearable>
								<el-option v-for="(item, index) in userList" :key="index" :label="item.userAccount" :value="item.userId"></el-option>
							</el-select>
						</div>
					</el-col>
					<el-col style="width:35%">
						<div class="hdp-uf">
							<div class="hdp-uf hdp-uf-vc">{{$t('m.primaryLedger')}}：</div>
							<el-select v-model="searchParam.primaryLedger" filterable style="width:70%;" clearable>
								<el-option v-for="(item, index) in accountList" :key="index" :label="item.label" :value="item.value"></el-option>
							</el-select>
						</div>
					</el-col>
                    <el-col style="width:30%">
                        <lap-search-btn :searchParam="searchParam" @successMethod="getDemoList()"></lap-search-btn>
                    </el-col>
				</el-row>
			</div>
		</div>
		<div class="table-container">
			<el-button type="primary" icon="el-icon-plus" plain @click="handleClick('add')"> {{$t('m.add')}} </el-button>
			<el-button type="info" icon="el-icon-delete" plain @click="handleDelete('batch')"> {{$t('m.delete')}} </el-button>
			<el-table
				ref="multipleTable"
				:data="tableData"
				stripe
				tooltip-effect="dark"
				style="width: 100%;margin: 24px 0"
				@select="handleSelect"
				@select-all="handleSelect">
				<el-table-column type="selection" width="35"></el-table-column>
				<el-table-column type="index"></el-table-column>
				<el-table-column :label="$t('m.OAAccount')" prop="account"></el-table-column>
				<el-table-column prop="primaryName" :label="$t('m.primaryLedger')"></el-table-column>
				<el-table-column :label="$t('m.operation')" align="right" width="150">
					<template slot-scope="scope">
						<el-button icon="el-icon-edit-outline" size='mini' plain @click="handleClick('modify', scope.row)"></el-button>
						<el-button type="danger" icon="el-icon-delete" size='mini' plain @click="handleDelete('single',scope.row)"></el-button>
					</template>
				</el-table-column>
			</el-table>
			<div class="hdp-uf">
                <a href="./static/template/数据权限模板.xlsx">
                    <el-button type="primary" icon="el-icon-download"> {{$t('m.dataTemplate')}} </el-button>
                </a>
                <lap-upload-file uploadUrl="/config/dataPermission/uploadedDataPermissionFile" @successMethod="getDemoList()"></lap-upload-file>
			</div>
            <lap-pagination :total="total" :searchParam="searchParam" @successMethod="getDemoList()"></lap-pagination>
		</div>
		<el-dialog
			:title="operateType=='add'? $t('m.add') :operateType=='modify'? $t('m.modify') :''"
			:visible.sync="dialogVisible"
			v-if="dialogVisible"
			width="30%">
			<div style="margin-left: 10%">
				<el-form ref="form" :model="form" :rules="rules" label-width="140px">
					<el-form-item :label="$t('m.OAAccount')" prop="accountId">
						<el-select v-model="form.accountId" filterable style="width:70%;">
							<el-option v-for="(item, index) in userList" :key="index" :label="item.userAccount" :value="item.userId"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item :label="$t('m.primaryLedger')" prop="primaryLedger">
						<el-select v-model="form.primaryLedger" filterable style="width:70%;">
							<el-option v-for="(item, index) in accountList" :key="index" :label="item.label" :value="item.value"></el-option>
						</el-select>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">{{$t('m.cancel')}}</el-button>
				<el-button type="primary" :disabled="addDisable" @click="haddleSave(operateType)">{{$t('m.sure')}}</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
export default {
	data() {
		return {
			title: {
				firstTitle: this.$t('m.LapModule'),
                secondTitle: this.$t('m.CONFIG_MANAGE'),
                thirdTitle: this.$t('m.DATA_PERMISSION')
			},
			userList: [],
			accountList: [],
			secondAccountList: [],
			searchParam: {      //查询参数
                account: '',
                primaryLedger: '',
                pageSize: 10,
                pageNum: 1,
            },
            form: {
            	accountId: '',
            	primaryLedger: '',
            	secondaryLedger: '',
            	dataPermissionId: ''
            },
            rules: this.$ruleApi.getRule('data'),
            tableData: [],
            total: 0,
            dialogVisible: false,
            operateType: '',    //操作类型 add新增 modify修改 view查看
            deleteDemoIdArr: [],
            addDisable: false
		}
	},
	methods: {
		getUserList() {
            this.$commonFunc.commonRequest('get', '/system/user/getVaildUserList')
            .then(res=>{
                this.userList = res.obj
            })
            .catch(res=>{
                this.$message.error(res.message)
            })
        },
        //获得主账套列表
        getAccountList(code) {
            this.$commonFunc.commonRequest('get', '/configValuesetLine/query/contentList', 'getValueSetLineByCode', {valuesetCode: code})
            .then(res=>{
                res.obj.forEach((o,i)=>{
                    this.accountList.push({label:o.valuesetLineContent, value:o.valuesetLineId})
                })
            })
            .catch(res=>{
                this.$message.error(res.message)
            })
        },
        getDemoList() {
            this.$commonFunc.commonRequest('get', '/config/dataPermission/getDataPermissionList', 'getDataList', this.searchParam)
            .then(res=>{
                this.tableData = res.obj.list
                this.total = res.obj.total
            })
            .catch(res=>{
                this.$message.error(res.message)
            })
        },
        addDemo() {
            this.$commonFunc.commonRequest('post', '/config/dataPermission/addDataPermission', 'addData', this.form)
            .then(res=>{
                this.$message.success(this.$t('m.addSuccess'))
                this.addDisable = false
                this.dialogVisible = false
                this.getDemoList()
            })
            .catch(res=>{
                this.$message.error(res.message)
                this.addDisable = false
            })
        },
        modifyDemo() {
            this.$commonFunc.commonRequest('post', '/config/dataPermission/updateDataPermission', 'modifyData', this.form)
            .then(res=>{
                this.$message.success(this.$t('m.modifySuccess'))
                this.dialogVisible = false
                this.getDemoList()
            })
            .catch(res=>{
                this.$message.error(res.message)
            })
        },
        //处理新增、修改、查看点击
        handleClick(type,row) {
            this.operateType = type
            this.dialogVisible = true
            //如果操作已有数据
            if(row) {
               	this.form = JSON.parse(JSON.stringify(row))
            } else {
                this.form = {
                    accountId: '',
            		primaryLedger: '',
            		secondaryLedger: ''
                }
            }
        },
        //弹框保存操作
        haddleSave(type) {
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    if(type=='add') {
                        this.addDisable = true
                        this.addDemo()
                    } else {
                        this.modifyDemo()
                    }
                } else {
                    return false;
                }
            });
        },
        handleDelete(type,row) {
            if( type == 'batch' && this.deleteDemoIdArr.length == 0) {
                this.$message.info(this.$t('m.chooseDelete'))
                return 
            }
            this.$confirm(this.$t('m.sureDelete'), this.$t('m.tips'), {
                confirmButtonText: this.$t('m.sure'),
                cancelButtonText: this.$t('m.cancel'),
                type: 'warning'
            })
            .then(() => {
                let demoIds = []
                if (type == 'single') {
                    demoIds.push(row.dataPermissionId)
                } else {
                	demoIds = this.deleteDemoIdArr
                }
                this.$commonFunc.commonRequest('post', '/config/dataPermission/batchDeleteDataPermission', 'deleteData', {dataPermissionIds: demoIds })
                .then(res=>{
                	this.$message.success(this.$t('m.deleteSuccess'))
                    this.deleteDemoIdArr = []
                	this.getDemoList()
                })
                .catch(res=>{
                	this.$message.error(res.message)
                })

            })
        },
        //处理单选
        handleSelect(row) {
            this.deleteDemoIdArr = []
            if(row.length) {
                for(var i = 0; i < row.length; i++) {
                    this.deleteDemoIdArr.push(row[i].dataPermissionId)
                }
            }
        },
	},
	mounted() {
		this.getUserList()
		this.getAccountList(this.$valueSetObj.MAIN_ACCOUNT)
		this.getDemoList()
	}
}
</script>
<style scoped>
.search-container {
	background: #ffffff;
	padding: 20px 20px 0 20px;
}

.table-container {
	padding: 24px;
	margin: 32px 0;
	background: #ffffff;
}

.block {
	text-align: right;
}
.file-btn{
	margin-left:10px;
}


.el-row {
	margin-bottom: 20px;
	&:last-child {
		margin-bottom: 0;
	}
}
.el-col {
	border-radius: 4px;
}
.bg-purple-dark {
	background: #99a9bf;
}
.bg-purple {
	background: #d3dce6;
}
.bg-purple-light {
	background: #e5e9f2;
}
.grid-content {
	border-radius: 4px;
	min-height: 36px;
}
.row-bg {
	padding: 10px 0;
	background-color: #f9fafc;
}
</style>



// WEBPACK FOOTER //
// src/pages/config/DataPermission.vue